/**
 * Monitoring / FinOps API service.
 */
import { api } from './api'
import type { HealthResponse, CostRecord, QuotaSettings } from '@/types'

export const monitoringApi = {
  getHealth: () => api.get<HealthResponse>('/health/ready/'),

  getCosts: () => api.get<CostRecord[]>('/admin/costs/'),

  getQuotas: () => api.get<QuotaSettings>('/admin/quotas/'),

  updateQuotas: (data: Partial<QuotaSettings>) =>
    api.patch<QuotaSettings>('/admin/quotas/', data),
}
